module.exports = __webpack_public_path__ + "static/intro-v2.01bfca66.mp4";